import ScrollReveal from "scrollreveal";

function scrollInit() {
  const options = {
    distance: "20%",
    speed: 900,
    delay: 300,
    origin: "bottom",
    opacity: 0,
    mobile: false,
  };
  ScrollReveal().reveal(".reveal", options);
}
scrollInit();